import React from 'react'
import "./skills.css"

const Skills = () => {
    const skills = [
        '.NET',
        '.NET (framework)',
        'JavaScript',
        'MS SQL',
        'Azure',
        'React',
        'Angular',
        'Node.js',
        'Terraform',
        'CI/CD',
        'Azure DevOps',
    ]

    return (
        <div className="skills-container">
            {skills.map(s => (
                <div className="skill" key={s}>{s}</div>
            ))}
        </div>
    )
}

export default Skills
